import { render } from "./delete.vue.js?vue&type=template&id=b25905be!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./delete.vue?vue&type=template&id=b25905be"
import script from "./delete.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__